export default "__VITE_ASSET__D4TVfS1S__"